<div class="location-message">
  <div class="location-preview-wrapper">
    <div class="location-preview" [ngStyle]="{'background-image': previewSrc}"></div>
  </div>
  <div class="location-address">{{address}}</div>
</div>